// Components==============
import Keyboard from 'components/Layout/ControlBar/components/Keyboard/Keyboard';
import InputField from 'components/UI/InputField/InputField';
import { BoxTypes } from 'components/UI/StatusBox/StatusBox';
import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'utilities/GlobalContext';
import './Keyboard.module.scss';
// =========================

export default function KeyboardTest() {
    const [value, setValue] = useState('');
    const [boxState, setBoxState] = useState<BoxTypes>('initial');
    const { setKeyboardIsOpen } = useContext(GlobalContext);

    useEffect(() => {
        setKeyboardIsOpen(true);

        return () => setKeyboardIsOpen(false);
    }, []);

    return (
        <div styleName="wrapper">
            <div styleName="text">
                <InputField
                    boxState={boxState}
                    setBoxState={setBoxState}
                    handleSubmit={(e) => {
                        e?.preventDefault();
                        setBoxState('correct');
                    }}
                    readOnly={false}
                    value={value}
                    setValue={setValue}
                />
            </div>
            <div styleName="keys">
                <Keyboard />
            </div>
        </div>
    );
}
